import * as mutations from './mutationNames';

export default {
    /**
     * Sets keys for both APIs:
     * @param {string} payload.apiKey key for maps APIs,
     * @param {string} payload.momaKey key for panorama (MoMa) API.
     * These keys are used throughout the application to access TomTom API services.
     */
    setKeys: ({ commit }, { apiKey, momaKey }) => {
        commit(mutations.SET_KEYS, { apiKey, momaKey });
    },
};
